import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const DeviceSummaryView = loadable(() => import('../components/Device/Views/DeviceSummaryView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('DeviceSummary own props', ownProps);
    return {
        contextCustomer: state.AppReducer.contextCustomer,
        userCustomers: state.AppReducer.userCustomers,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('DeviceSummary Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DeviceSummaryView);
